<template>
  <div ref="layout">
    <slot />
  </div>
</template>

<script>
let cached = []

export default {
  props: ['top', 'bottom'],
  name: 'ScrollEvent',
  created () {
    this.handleScroll = this.handleScroll.bind(this)
  },
  mounted () {
    console.log('装载中')
    this.__bottom = this.bottom || 1
    this.__top = this.top || 0
    this.__bottom = this.__bottom > 1 ? 1 : this.__bottom < 0 ? 1 : this.__bottom
    this.__top = this.__top > 1 ? 0 : this.__top < 0 ? 0 : this.__top
    if (this.__bottom < this.__top) {
      this.__bottom = 1
      this.__top = 0.8
    }

    this.readyClass = '__ready'
    this.completeClass = '__complete'
    this.activeClass = '__arrive'
    this.doms = [].slice.call(this.$refs.layout.children)

    let loadPims = this.doms.map(dom => {
      let loadPims = [].map.call(dom.querySelectorAll('img'), img => {
        return new Promise((resolve) => {
          if (~cached.indexOf(img)) {
            resolve(1)
          } else {
            img.addEventListener('load', () => resolve(1))
            img.addEventListener('error', () => resolve(1))
            setTimeout(() => {
              resolve(1)
            }, 2000)
          }
        })
      })

      dom.classList.add(this.readyClass)
      return Promise.all(loadPims)
    })

    console.log(loadPims)
    Promise.all(loadPims).then(r => {
      console.log('next loadPims')
      this.doms.forEach(dom => {
        let top = this.getPositionY(dom)
        dom.classList.remove(this.readyClass)
        dom.classList.add(this.completeClass)
        dom.minScrollEvnetHeight = top + dom.offsetHeight * this.__top
        dom.maxScrollEvnetHeight = top + dom.offsetHeight * this.__bottom
        window.addEventListener('scroll', this.handleScroll, {passive: true})
        this.scroll()
      })
    })
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => this.scroll(), 20)
    },
    getPositionY (dom) {
      let y = 0
      while (dom && dom !== document.body && dom !== document.documentElement) {
        y += dom.offsetTop
        dom = dom.offsetParent
      }
      return y
    },
    scroll () {
      this.doms.forEach((dom, index) => {
        let height = (window.scrollY || window.pageYOffset) + window.innerHeight
        if (height >= dom.minScrollEvnetHeight &&
            height <= dom.maxScrollEvnetHeight + window.innerHeight) {
          if (!dom.__active__state) {
            dom.classList.add(this.activeClass)
            dom.__active__state = true
            this.$emit('focusChange', index)
          }
        } else {
          if (dom.__active__state) {
            dom.classList.remove(this.activeClass)
            dom.__active__state = false
            this.$emit('blurChange', index)
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Scroll/index.vue